import { CSSProperties, memo } from 'react';

import './Skeleton.css';

type SkeletonProps = {
  width: CSSProperties['width'];
  height: CSSProperties['height'];
  borderRadius?: CSSProperties['borderRadius'];
  style?: CSSProperties;
};

export const Skeleton = memo(
  ({ width, height, borderRadius, style }: SkeletonProps) => {
    return (
      <div
        className="skeleton"
        style={{ width, height, borderRadius, ...style }}
      />
    );
  },
);
